export enum UserRole {
    Admin = 'admin',
    DungeonMaster = 'dungeon-master/game-master',
    Player = 'player',
}

function isUserRole(value: unknown): value is UserRole {
    return Object.values(UserRole).includes(value as UserRole);
}

export default class User {
    id!: string;
    name!: string;
    username!: string;
    email!: string;
    password!: string;
    roles: UserRole[] = [];

    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);

            const incomingRoles = Array.isArray(data.roles)
                ? data.roles
                : data.role
                    ? [data.role]
                    : [];

            this.roles = incomingRoles.filter(isUserRole);
        }
    }
}
